import React from 'react';
import { Link, Modal, ModalClose, Sheet, Table, Typography } from '@mui/joy';
import { IConflictLog } from '../interface/IWorklog';

type Props = {
  open: boolean;
  closeModal: () => void;
  conflictIssues: IConflictLog[];
  onIgnore: (issueId: string) => void;
};

const ConflictIssuesModal = ({ open, closeModal, conflictIssues, onIgnore }: Props) => {
  return (
    <Modal
      aria-labelledby='modal-title'
      aria-describedby='modal-desc'
      open={open}
      onClose={closeModal}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Sheet
        variant='outlined'
        sx={{
          maxWidth: 1200,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
        }}
      >
        <ModalClose variant='plain' sx={{ m: 1 }} />
        <Typography component='h2' id='modal-title' level='h4' textColor='inherit' fontWeight='lg' mb={1}>
          Conflict Issues
        </Typography>
        <Sheet
          sx={{
            display: { xs: 'none', sm: 'initial' },
            width: '100%',
            borderRadius: 'sm',
            flexShrink: 1,
            overflow: 'auto',
            minHeight: 0,
            // pl: 6,
            // p: 1,
          }}
        >
          {conflictIssues && (
            <Table
              noWrap
              borderAxis='bothBetween'
              stickyHeader
              size='sm'
              variant='soft'
              sx={{
                '--TableCell-headBackground': 'var(--joy-palette-background-level3)',
                '--Table-headerUnderlineThickness': '1px',
                '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
                '--TableCell-paddingY': '4px',
                '--TableCell-paddingX': '8px',
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: '8%' }}>Project</th>
                  <th style={{ width: '4%' }}>Issue Key</th>
                  <th style={{ width: '20%' }}>Summary</th>
                  <th style={{ width: '5%' }}>Type</th>
                  <th style={{ width: '7%' }}>Reason</th>
                  <th style={{ width: '5%' }}>Action</th>
                  {/* <th style={{ width: '8%' }}>Start Date</th>
                <th style={{ width: '5%' }}>Time Logged</th> */}
                </tr>
              </thead>
              <tbody>
                {conflictIssues.map((issue: IConflictLog, logIndex) => (
                  <tr key={issue.id}>
                    <td>
                      {issue.project.key}/{issue.project.name}
                    </td>
                    <td>
                      <Link slotProps={{ root: { target: '_blank' } }} href={`https://public7.atlassian.net/browse/${issue.key}`} underline='always'>
                        {issue.key}
                      </Link>
                    </td>
                    <td>{issue.summary}</td>
                    <td>{issue.type}</td>
                    <td>{issue.conflictReason}</td>
                    <td>
                      <Link onClick={() => onIgnore(issue.id)} disabled={issue.conflictReason == 'Both' || issue.conflictReason == 'Parent'}>
                        Ignore
                      </Link>
                    </td>

                    {/* <td>
                        {log.startDate} {log.startTime}
                      </td>
                      <td>{getTimeLoggedStringFormat(log.timeLogged)}</td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Sheet>
      </Sheet>
    </Modal>
  );
};

export default ConflictIssuesModal;
